module.exports = __webpack_public_path__ + "img/6-3.95ba3528.png";